import type { ReactNode } from 'react';

import { FlaskConicalIcon } from 'lucide-react';

import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';

interface EmptySimulationsProps {
  title: string;
  description: string;
  action?: ReactNode;
}

export const EmptySimulations = ({ title, description, action }: EmptySimulationsProps) => (
  <Empty>
    <EmptyHeader>
      <EmptyMedia variant="icon">
        <FlaskConicalIcon aria-hidden />
      </EmptyMedia>
      <EmptyTitle>{title}</EmptyTitle>
      <EmptyDescription>{description}</EmptyDescription>
    </EmptyHeader>
    {action && <EmptyContent>{action}</EmptyContent>}
  </Empty>
);
